export enum ReturnsPackageDetailTypes {
  RETURNS_GET_PACKAGE_DETAILS_SUCCESS = "RETURNS_GET_PACKAGE_DETAILS_SUCCESS",
  RESET_RETURN_PACKAGE_DETAILS = "RESET_RETURN_PACKAGE_DETAILS",
  RETURN_GET_PACKAGE_ITEM_DETAILS_SUCCESS = "RETURN_GET_PACKAGE_ITEM_DETAILS_SUCCESS",
}
